// Hook odpowiedzialny za pobranie listy produktów z typu subelementu produktu po typie (string)

import axios from 'api/axios';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  IProductListItem
} from 'api/types';

// parametry requestu do api
type IRequest = IPaginationRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IProductListItem>;

const getProductSubelementItemsByType = (
  productId: number,
  typeId: string,
  params?: IRequest
): Promise<IResponse> =>
  axios.get(`/products/${productId}/subelements/${typeId}`, { params });

export const useGetProductSubelementItemsByType = (
  productId: number,
  typeId: string,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['product-subelement-items-by-type', productId, typeId, params],
    () => getProductSubelementItemsByType(productId, typeId, params),
    options
  );

